import React from 'react';
import { useTranslation } from 'react-i18next';

import DashboardCard from '../../Layout/DashboardCard';
import TableDataParse from './TableDataParse';

function VirtualAnalyzerFrequentURL(props: { data: any; day: string }) {
  const { t } = useTranslation();

  return (
    <DashboardCard
      title={t('dashboard.chart.title.virtualAnalyzerFrequentURL')}
    >
      <TableDataParse
        data={props.data}
        type="URL"
        day={props.day}
        timeFormat={t('common.momentDateFormat')}
      />
    </DashboardCard>
  );
}

export default React.memo(VirtualAnalyzerFrequentURL);
